theme.slick_slider = function(){
  $('.icon_with_text_main').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.collection_product_slider_main .slider-content')?.slick({
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    asNavFor: '.collection_product_slider_main .slider-thumb',
    arrows: true
  });
  $('.collection_product_slider_main .slider-thumb')?.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.collection_product_slider_main .slider-content',
    dots: true,
    infinite: true,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.collection_product_slider_main .slider-thumb').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var dataColor = $(event.currentTarget).parents('.collection_product_slider_main').find('.product_item.slick-current').attr('data-color');
    $(event.currentTarget).parents('.collection_product_slider_main').css('background-color', dataColor);
  });

}

theme.bgColorChange = function(){
  var dataColor = $('.product_item.slick-current').attr('data-color');
  $('.collection_product_slider_main').css('background-color', dataColor);
}

theme.testimonial_slider = function(){
  $('.multi_media_slider').slick({
    infinite: true,
    slidesToShow: 2,
    arrows:false,
    centerMode: true,
    centerPadding: '60px',
    focusOnSelect: true,
    autoplay:true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: '40px'
        }
      },
      
    ]
  });
}

theme.clickEvent = function(){
  $(document).on('click', '.pdp_faq_main .faq_main_heading .faq_heading', function(){
    $(this).parents('.faq_main_heading').toggleClass('active');
  });
  $(document).on('click', '.pdp_faq_main .faq_item .faq_title', function(){
    $(this).closest('.faq_sub').toggleClass('active');
  });

  $(document).on('click', '.main__item_card .card__bottom .left_side', function(){
    $(this).parents('.inner__card_main').toggleClass('active');
  });

  $(document).on('click', '.collection_tab_main .collection_tab_menu .tab_title', function(){
    $(this).parents('.collection_tab_main').find('.collection_tab_menu .tab_title').removeClass('active');
    $(this).addClass('active');
  });

  $(document).on('click', '.collection_tab_main .add_basket_main .plus', function(e){
    var currentValue = parseInt($(this).prev().val());
    if(currentValue < 3) {
      $(this).prev().val(currentValue + 1);
    }

    $parents = $(this).parents('.add_basket_main');
    var timeStamp = e.timeStamp;
    productPackAdd($parents, timeStamp);
  });
  
  $(document).on('click', '.collection_tab_main .add_basket_main .minus_btn', function(e){
    var currentValue = parseInt($(this).parents('.quantity_main').find('.quantity-input').val());
    if(currentValue > 0) {
      $(this).parents('.quantity_main').find('.quantity-input').val(currentValue - 1);
    }
    if(currentValue == 1){
      $(this).parents('.add_basket_main').find('.product_add').removeClass('hidden');
      $(this).parents('.add_basket_main').find('.quantity_main').addClass('hidden');
    }
    
    $parents = $(this).parents('.add_basket_main');
    $parents.parents('.collection_tab_main').find('.product_add').attr('disabled', false);
    $parents.parents('.collection_tab_main').find('.quantity_main .plus').attr('disabled', false);
  });

  $(document).on('click', '.collection_tab_main .add_basket_main .minus', function(e){
    var currentValue = parseInt($(this).next().val());
    if(currentValue > 0) {
      $(this).next().val(currentValue - 1);
    }
    if(currentValue == 1){
      $(this).parents('.add_basket_main').find('.product_add').removeClass('hidden');
      $(this).parents('.add_basket_main').find('.quantity_main').addClass('hidden');
    }

    $parents = $(this).parents('.add_basket_main');
    var timeStamp = e.timeStamp;
    productPackDelete($parents, timeStamp);
  });

  $(document).on('click', '.collection_tab_main .add_basket_main .product_add', function(e){
    $parents = $(this).parents('.add_basket_main');
    $parents.find('.quantity_main .quantity-input').val(1);
    $parents.find('.quantity_main').removeClass('hidden');
    $(this).addClass('hidden');
    
    var timeStamp = e.timeStamp;
    productPackAdd($parents, timeStamp);
  });

  $(document).on('click', '.collection_tab_main .product-pack__item .product_pack__item_remove', function(){
    var timeStamp = $(this).parents('.product-pack__item').attr('time-stamp');
    $parent = $(this).parents('.product-pack__item');
    
    if($parent.find('.product__1.hidden').length == 0){
      $parent.find('.product__1').addClass('hidden');
      $parent.find('.product_pack__wrap.empty_product_show').removeClass('hidden');
    }
    if($parent.find('.product__2.hidden').length == 0){
      $parent.find('.product__2').addClass('hidden');
      $parent.find('.product_pack__wrap.empty_product_show').removeClass('hidden');
    }
    if($parent.find('.product__3.hidden').length == 0){
      $parent.find('.product__3').addClass('hidden');
      $parent.find('.product_pack__wrap.empty_product_show').removeClass('hidden');
    }

    if($(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main[time-stamp-1="${timeStamp}"]`).length > 0){
      // console.log('aaa');
      $(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main[time-stamp-1="${timeStamp}"]`).find('.quantity_main .minus_btn').click();
      $(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main`).removeAttr('time-stamp-1');
    }else if($(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main[time-stamp-2="${timeStamp}"]`).length > 0){
      // console.log('bbb');
      $(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main[time-stamp-2="${timeStamp}"]`).find('.quantity_main .minus_btn').click();
      $(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main`).removeAttr('time-stamp-2');
    }else if($(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main[time-stamp-3="${timeStamp}"]`).length > 0){
      // console.log('ccc');
      $(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main[time-stamp-3="${timeStamp}"]`).find('.quantity_main .minus_btn').click();
      $(this).parents('.collection_tab_main').find('.add_basket_main .product_add.hidden').parents(`.grid__item`).find(`.add_basket_main`).removeAttr('time-stamp-3');
    }
    
    $parent.removeClass('active');
    $parent.parents('.product_pack__items').find('.product-pack__item:not(.active)').appendTo('.product_pack__items');
    titlechange($parent);
    theme.productPriceUpdate();

    // console.log('timeStamp');
  });

  function productPackAdd($parents, timeStamp){
    var totalQ = 0;
    $('.product_add.hidden').parents('.add_basket_main').find('.quantity_main input').each(function(){
      var totalQty = parseInt($(this).val());
      totalQ += totalQty;
    });
    if(totalQ == 3){
      $parents.parents('.collection_tab_main').find('.product_add').attr('disabled', true);
      $parents.parents('.collection_tab_main').find('.quantity_main .plus').attr('disabled', true);
    }

    var productTitle = $parents.find('.variant_data').attr('product-title');
    var variantId = $parents.find('.variant_data').attr('variant-id');
    var variantImg = $parents.find('.variant_data').attr('variant-img');
    var comparePrice = $parents.find('.variant_data').attr('compare-price');
    var defaultPrice = $parents.find('.variant_data').attr('default-price');

    if($parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1.hidden').length > 0){
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1.hidden').parents('.product-pack__item').find('.empty_product_show').addClass('hidden');
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1.hidden').removeClass('hidden');

      $parents.attr('time-stamp-1', timeStamp);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1').parents('.product-pack__item').attr('time-stamp', timeStamp);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1').parents('.product-pack__item').attr('variant-id', variantId);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1 .product_pack__item_img').attr('src', variantImg);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1').parents('.product-pack__item').find('.product_pack__item_title').text(productTitle);

      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1').parents('.product-pack__item').addClass("active");
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1').parents('.product-pack__item').attr('compare-price', comparePrice);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__1').parents('.product-pack__item').attr('default-price', defaultPrice);

    }else if($parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2.hidden').length > 0){
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2.hidden').parents('.product-pack__item').find('.empty_product_show').addClass('hidden');
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2.hidden').removeClass('hidden');

      $parents.attr('time-stamp-2', timeStamp);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2').parents('.product-pack__item').attr('time-stamp', timeStamp);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2').parents('.product-pack__item').attr('variant-id', variantId);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2 .product_pack__item_img').attr('src', variantImg);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2').parents('.product-pack__item').find('.product_pack__item_title').text(productTitle);

      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2').parents('.product-pack__item').addClass("active");
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2').parents('.product-pack__item').attr('compare-price', comparePrice);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__2').parents('.product-pack__item').attr('default-price', defaultPrice);

    }else if($parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3.hidden').length > 0){
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3.hidden').parents('.product-pack__item').find('.empty_product_show').addClass('hidden');
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3.hidden').removeClass('hidden');

      $parents.attr('time-stamp-3', timeStamp);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3').parents('.product-pack__item').attr('time-stamp', timeStamp);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3').parents('.product-pack__item').attr('variant-id', variantId);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3 .product_pack__item_img').attr('src', variantImg);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3').parents('.product-pack__item').find('.product_pack__item_title').text(productTitle);

      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3').parents('.product-pack__item').addClass("active");
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3').parents('.product-pack__item').attr('compare-price', comparePrice);
      $parents.parents('.collection_tab_main').find('.product_pack__items .main_pack_product .product__3').parents('.product-pack__item').attr('default-price', defaultPrice);

      $parents.parents('.collection_tab_main').find('.product_add').attr('disabled', true);
      $parents.parents('.collection_tab_main').find('.quantity_main .plus').attr('disabled', true);

    }

    $parents.parents('.collection_tab_main').find('.product-pack__item:not(.active)').appendTo('.product_pack__items');
    $parent = $('.product-pack__item');
    titlechange($parent);

    theme.productPriceUpdate();
  }

  function productPackDelete($parents, timeStamp){
    console.log('Delete pack');
    
    $parents.parents('.collection_tab_main').find('.product_add').attr('disabled', false);
    $parents.parents('.collection_tab_main').find('.quantity_main .plus').attr('disabled', false);

    var timeStamp1 = $parents.attr('time-stamp-1');
    var timeStamp2 = $parents.attr('time-stamp-2');
    var timeStamp3 = $parents.attr('time-stamp-3');

    if($parents.attr('time-stamp-1')){
      $parents.removeAttr('time-stamp-1');
      $parents.parents('.collection_tab_main').find(`.product_pack__items .product-pack__item.active[time-stamp="${timeStamp1}"]`).find('.product_pack__item_remove').click();
    }else if($parents.attr('time-stamp-2')){
      $parents.removeAttr('time-stamp-2');
      $parents.parents('.collection_tab_main').find(`.product_pack__items .product-pack__item.active[time-stamp="${timeStamp2}"]`).find('.product_pack__item_remove').click();
    }else if($parents.attr('time-stamp-3')){
      $parents.removeAttr('time-stamp-3');
      $parents.parents('.collection_tab_main').find(`.product_pack__items .product-pack__item.active[time-stamp="${timeStamp3}"]`).find('.product_pack__item_remove').click();
    }

    theme.productPriceUpdate();
  }

  function titlechange($parent){
    var counter = 0;
    $parent.parents('.product_pack__items').find('.product-pack__item:not(.active)').find('.product_pack__item_title').each(function(){
      counter ++;
      
      if($parent.parents('.product_pack__items').find('.product-pack__item:not(.active)').find('.product_pack__item_title').length == 1){
        $(this).text('3. Ürün');
      }else if($parent.parents('.product_pack__items').find('.product-pack__item:not(.active)').find('.product_pack__item_title').length == 2){
        $parent.parents('.product_pack__items').find('.product-pack__item.active').next().find('.product_pack__item_title').text('2. Ürün');
        $parent.parents('.product_pack__items').find('.product-pack__item.active').next().next().find('.product_pack__item_title').text('3. Ürün');
      }else if($parent.parents('.product_pack__items').find('.product-pack__item:not(.active)').find('.product_pack__item_title').length == 3){
        $(this).text(counter + '.Ürün');
      }
    });
  }

  function cartDataGet(){
    var url = `/?section_id=cart-drawer`;
    $.ajax({
      url: url,
      success: function(data) {
        const html = new DOMParser().parseFromString(data, "text/html");
        var mainContentElement = html.getElementById('custom_drawer');
    
        if (mainContentElement) {
          var product_html_new = mainContentElement.innerHTML;
          document.getElementById('custom_drawer').innerHTML = product_html_new;
          $('.custom_item_count').text($(product_html_new).find('#CartDrawer').attr('data-count'));
          // $('#custom_drawer cart-drawer.drawer').addClass("active");
          // $('body').addClass('overflow-hidden');
          $('#cart-icon-bubble')[0].click();
        } else {
          console.error("Element with ID 'mainContentElement' not found in the returned HTML");
        }
      }
    });
  }

  function ProductAddOn(formData){
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      data: JSON.stringify(formData),
      dataType: 'json',
      success: function(line_item) { 
        cartDataGet();
      },
      error: function() {
        console.log("fail");
      }
    };
    $.ajax(params);
  }

  theme.bundleAddToCart = function(){
    let itemsArr = new Array();
    checkedValues = [];
    $(".product_pack__items li.active").each(function() { 
      itemsArr.push({'id':parseInt($(this).attr("variant-id")),'quantity': 1});
    });
    let formData = {
      items: itemsArr,
    }
    // console.log(formData.items.length);
    if(formData.items.length == 3){
      ProductAddOn(formData);
    }else{
      alert("select any three product.")
    }
  }

  theme.productPriceUpdate = function(){
    var comparePrices = 0;
    var defaultPrices = 0;
    var currencyCode = $(".custom_currency_get").val();
    $(".product_pack__items li.active").each(function() { 
      comparePrices += parseInt($(this).attr("compare-price"));
      defaultPrices += parseInt($(this).attr("default-price"));
    });
    $(".bundle_price .compare_price del").html(currencyCode + (comparePrices / 100).toFixed(2));
    $(".bundle_price .price del").html(currencyCode + (defaultPrices / 100).toFixed(2));
    var totalPrice = (defaultPrices / 100).toFixed(2);
    var discountPer = $('.collection_tab_main .collection_tab_sub').attr('data-discount');
    var total = ((totalPrice * discountPer)/100);
    var totalDiscountPrice = totalPrice - total.toFixed(2);
    $(".discount_price .dis").html(currencyCode + total.toFixed(2));
    $(".add_discount_price").html(currencyCode + totalDiscountPrice.toFixed(2));
  }
}


theme.guarenteed_accordian = function(){
  $(".accordian_heading").on("click", function(){
    $(this).closest(".guarenteed_accordian").toggleClass("active");
  });
}

theme.pdp_happiness_accordian = function(){
  $(".happiness_accordian_heading").on("click", function(){
    $(this).closest(".happiness_accordian").toggleClass("active");
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  theme.slick_slider();
  theme.bgColorChange();
  theme.testimonial_slider();
  theme.clickEvent();
  theme.guarenteed_accordian();
  theme.pdp_happiness_accordian();

  $(document).on('click', '.custom_bundle_button button', function(){
    theme.bundleAddToCart();
  });
    // setTimeout(function() {
    //   $('.testimonial_pdp__main').removeClass('hidden');
    // }, 2000);
});